import React from 'react'
import "./Home.css"
import ReactWhatsapp from 'react-whatsapp';
function Home() {
    return (
        <div className='container cont-width d-flex justify-content-center align-items-center'>
            <div className='row d-flex justify-content-center'>
                <div className='col-md-7  col-11'>
                    <h3 className='home-h3'>TRADEFLARE LTD</h3>
                    <p className='home-p'>
TRADEFLARE  is a technology company specializing in blockchain development, full-stack web applications, and scalable backend solutions using modern technologies like React and Node.js.
                    </p>
                    <p className='home-p'>
                        <span>💻 Frontend Development Services:</span> <br />
                        We build modern, responsive, and high-performance frontend applications using technologies such as HTML, CSS, JavaScript, React.js, Next.js, TypeScript, Redux Toolkit, and Tailwind CSS.

Our focus is on creating scalable, user-friendly, and visually appealing interfaces with clean architecture and optimized performance.
                    </p>
                    <p className='home-p'>
                        ⚙️ Backend Development Services: <br />
                        ExpressJs, MongoDB, MySQL, Payment Gateway Integration, Create Restful APIs,
                    </p>
                    <p className='home-p'>
                        ⛓️ Blockchain Development Services: <br />
                        Building cryptocurrencies (ERC20, ERC777), NFT (ERC721, ERC721-A, ERC1155), staking, minting and marketplace dapps, defi dapps, decentralized exchange and decentralized donation platform. Contact TRADEFLARE  to discuss your requirements.
                    </p>


                    <div class="button-container-2">
                        <span class="mas">Get In Touch</span>
                        <ReactWhatsapp number="+447307692707" message="Hello Tradeflare , I would like to discuss a project." style={{ backgroundColor: "transparent" }} />
                        {/* <a href='https://wa.me/+92 303 6954689'>
                            <button type="button" name="Hover">Contact Me</button>
                            </a> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home